import React from 'react'
import { css } from '@emotion/css'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import {
  IconBugTrackerArrow,
  IconProps
} from '@contrast-security-inc/design-system-foundations'
import { BugTrackerTooltipContent } from './bug-tracker-tooltip-content'
import { BugTracker } from '.'

const iconCss = css`
  align-self: center;
  transform: translateY(-1px);
`

export function BugTrackerTooltip({
  bugTrackers,
  iconClassName,
  iconColor,
  tooltipClassName,
  organizationID,
  vulnerabilityID
}: {
  readonly bugTrackers: BugTracker[]
  readonly iconClassName?: string
  readonly iconColor?: IconProps['color']
  readonly tooltipClassName?: string
  readonly organizationID: string
  readonly vulnerabilityID: string
}) {
  return (
    <Tooltip
      interactive
      placement="bottom"
      body={
        <div className={tooltipClassName ? tooltipClassName : undefined}>
          <BugTrackerTooltipContent
            bugTrackers={bugTrackers}
            organizationID={organizationID}
            vulnerabilityID={vulnerabilityID}
          />
        </div>
      }
    >
      <span className={iconClassName ? iconClassName : iconCss}>
        <IconBugTrackerArrow
          size="md"
          color={iconColor ? iconColor : 'neutral60'}
        />
      </span>
    </Tooltip>
  )
}
